import React, { useState } from "react"
import LazyImage from "../../components/LazyImage"
import PlusIcon from "../../components/icons/PlusIcon"
import MinusIcon from "../../components/icons/MinusIcon"

import "./index.scss"

const CaseDeveloper = ({ image, desc, name, text, header }) => {
    const [showMore, setShowMore] = useState(false)

    return (
        <div className="case-developer">
            {header && <h1 className="t-s3 mob">{header}</h1>}
            <LazyImage src={image} alt="developer" />
            <div className="case-developer-info">
                <h3 className="t-s1-m">{name}</h3>
                <hr />
                <h5 className="t-b4">{desc}</h5>
            </div>
            <div className="case-developer-text">
                <hr />
                <div data-showfull={showMore}>
                    {text.map((el, id) => (
                        <p key={id} className="t-b3">
                            {el}
                        </p>
                    ))}
                </div>
                {showMore && <hr/>}
                <h6 className="t-nav" onClick={() => setShowMore(!showMore)}>
                    {!showMore ? "LEARN MORE" : "COLLAPSE"}{" "}
                    {!showMore ? <PlusIcon /> : <MinusIcon />}
                </h6>
            </div>
        </div>
    )
}

export default CaseDeveloper
